import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { angRoutes } from '../constants/router';
import { AccessService } from '../services/access/access.service';

export const guestGuard: CanActivateFn = () => {
  const accessService = inject(AccessService);
  const router = inject(Router);

  return accessService.isLoggedIn() ? router.createUrlTree([angRoutes.dashboard.route]) : true;
};
